import { render, staticRenderFns } from "./_travel-tile-item.vue?vue&type=template&id=556b60c4"
import script from "./_travel-tile-item.vue?vue&type=script&lang=js"
export * from "./_travel-tile-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports